import * as yup from 'yup';
import { DEFAULT_FIELD_ERROR } from './constants';

const innSchema = yup.string().matches(/^\d{10}$/, DEFAULT_FIELD_ERROR);
export default innSchema;
